//really, view and control combined here. 

'use strict';
var $ = require('jquery');
var modalView = require('./modal');
var tracker = require('./tracking');
var basepath = require('./basepath'); 



var template = '';
template += '<div class="question-view">';
template += '   <div class="selector-hero">';
template += '       <div class="hero-container">';
template += '           <h1 class="hero-title"></h1>';
template += '           <div class="why-are-we-asking-container"><a class="why-are-we-asking">Why are we asking?</a></div>';
template += '       </div>';
template += '   </div>';
template += '    <div class="question-number"></div>';
template += '    <div class="answers-container"></div>';
template += '    <div class="selector-ui">';
template += '       <div class="selector-ui-innter">';
template += '        <button class="previous-question-button  previous-questions previous-default">Previous</button>';
template += '        <button class="selector-button next-questions" disabled>Next</button><br>';
template += '        <button class="previous-question-button  previous-questions previous-mobile">Previous</button>';
template += '        </div>';
template += '    </div>';
template += '</div>';

function makeAnswer(answerText, answerGroupName, answerNumber) {
    var html = '';
    html += '<div class="answer">';
    html += '<label class="answer-label" for="' + (answerGroupName + answerText) + '">';
    html += '    <input class="checkbox-input2" type="radio" name="' + answerGroupName + '" id="' + (answerGroupName + answerText) + '" value=' + answerNumber + ' />';
    html += '    <div class="checkmark-green">';
    html += '       <div class="checkmark-unchecked"></div>';
    html += '       <img src="' + basepath.getPath('media/icons/green-check.svg') + '">';
    html += '    </div>';
    html += '    <span class="answer-label-text">' + answerText + '</span>';
    html += '</label>';
    html += '</div>';

    var $answer = $(html);
    return $answer;
}

function makeGroupQuestion(data, answerGroupName, isPersonal) {
    var updateCallback = null;
    var hasAnswered = false;
    var answerNumber = null;

    var html = '<div class="multi-question-item">';
    html += '<div class="answer-row-label">';
    html += '<div class="answer-row-label-container-inner">';
    html += '    <h4>' + data.getQueryText() + '</h4>';
    html += '    <div class="info-icon-container">';
    html += '        <img class="questionmark-icon" src="' + basepath.getPath('media/icons/ic_help_blue_24px.svg') + '">';
    html += '        <img class="questionmark-icon-dark" src="' + basepath.getPath('media/icons/ic_help_darkblue_24px.svg') + '">';
    html += '    </div>';
    html += '    </div>';
    html += '</div>';
    html += '</div>';


    var $el = $(html);

    if (data.getWhy().length > 0) {
        $el.addClass('show-info-button');
    }
    $el.find('.info-icon-container').on('click', function() {
        tracker.trackEvent({
            category: 'Chair Selector',
            action: 'view help',
            label: data.getQueryText()
        });

        modalView.show({
            title: data.getQueryText(),
            body: data.getWhy()
        });
    });

    var numberOfAnswers = data.numberOfAnswers;

    for (var i = 0; i < numberOfAnswers; i += 1) {
        var labelText = data.getAnswerText(i, isPersonal);
        var $answer = makeAnswer(labelText, answerGroupName, i);
        $el.append($answer);
    }

    var $radios = $el.find('input');

    $radios.change(function() {
        hasAnswered = true;
        answerNumber = parseInt($(this).val());
        if (updateCallback) {
            updateCallback();
        }

        var $selectedRadio = $('input[name=' + answerGroupName + ']:radio:checked');
        var $checkmark = $selectedRadio.next().find('img');
        $checkmark.fadeIn(250);

        $selectedRadio.siblings('.answer-label-text').addClass('selected-answer');


        var $unselectedRadio = $('input[name=' + answerGroupName + ']:radio:not(:checked)');
        var $checkmarkHide = $unselectedRadio.next().find('img');
        $checkmarkHide.fadeOut('fast');
        $unselectedRadio.siblings('.answer-label-text').removeClass('selected-answer');
    });


    return {
        get $el() {
            return $el;
        },
        get hasAnswered() {
            return hasAnswered;
        },
        get data() {
            return data;
        },
        get answerNumber() {
            return answerNumber;
        },
        reset: function() {
            answerNumber = null;
            hasAnswered = false;
            $radios.prop('checked', false);

            $el.find('.answer-label-text').removeClass('selected-answer');
            var $unselectedRadio = $('input[name=' + answerGroupName + ']:radio:not(:checked)');
            var $checkmarkHide = $unselectedRadio.next().find('img');
            $checkmarkHide.hide();
        },
        onAnswerSelect: function(callback) {
            updateCallback = callback;
        }
    };
}

function makeNewView(data, questionNumber) {
    if (data.isGroup !== true) {
        return makeNewSoloView(data, questionNumber);
    } else {
        return makeNewGroupView(data, questionNumber);
    }
}

function makeNewGroupView(data, questionNumber) {
    var isPersonal = false;

    var selectCallback = null,
        nextCallback = null,
        previousCallback = null,
        whyCallback;

    var $el = $(template);
    var $answersContainer = $el.find('.answers-container');

    var questionViewsArray = [];

    var populate = function() {
        $el.find('.hero-title').html(data.getQueryText(isPersonal));
        $answersContainer.html('');

        var questions = data.questions;

        function checkIfAllQuestionsAnswered() {
            var allchecked = true;
            questionViewsArray.forEach(function(questionView) {
                if (questionView.hasAnswered === false) {
                    allchecked = false;
                }
            });


            if (allchecked === true) {
                $next.prop('disabled', false);
            }
        }

        function updateSelect() {
            var callbackData = {
                questionData: data,
                questions: []
            };

            questionViewsArray.forEach(function(questionView) {

                if (questionView.hasAnswered === true) {
                    callbackData.questions.push({
                        questionData: questionView.data,
                        answerNumber: questionView.answerNumber
                    });
                }
            });
            checkIfAllQuestionsAnswered();
            selectCallback(callbackData);
        }


        questions.forEach(function(question, i) {
            var answerGroupName = 'answer-group-' + questionNumber + '-' + i;
            var questionView = makeGroupQuestion(question, answerGroupName, isPersonal);
            questionViewsArray.push(questionView);



            $answersContainer.append(questionView.$el);



            questionView.onAnswerSelect(function() {
                updateSelect();
            });

        });
    };

    var $next = $el.find('.next-questions');
    var $previous = $el.find('.previous-questions');

    populate();

    var view = {
        $el: $el,
        updatePersonalTrack: function(p) {
            isPersonal = p;

        },
        onWhy: function(callback) {
            whyCallback = callback;
        },
        onAnswerSelect: function(callback) {
            selectCallback = callback;
        },
        onNext: function(callback) {
            nextCallback = callback;
        },
        onPrevious: function(callback) {
            previousCallback = callback;
        },
        reset: function() {
            questionViewsArray.forEach(function(questionView) {
                questionView.reset();
            });
            $next.prop('disabled', true);


        },
        enabled: function(isEnabled, questionNumber, dontScrollOnStart, totalQuestions, resetAnswerOfCurrentQuestion) {
            if (!isEnabled) {
                $el.hide();

            } else {

                $el.fadeIn('fast');

                if (resetAnswerOfCurrentQuestion === true) {
                    view.reset();
                }

                $el.find('.question-number').html('Step ' + (questionNumber + 1) + ' of ' + totalQuestions);
            }
        },
        isLast: function() {
            $next.html('Submit');
        },
        clear: function() {
            $el.find('input').attr('checked', false);
        },
        get id() {
            return data.queryID;
        }
    };

    $next.on('click', function() {
        if (!!nextCallback) {
            nextCallback();
        }
    });
    $previous.on('click', function() {
        if (!!previousCallback) {
            previousCallback();
        }
    });

    var $why = $el.find('.why-are-we-asking');

    $why.on('click', function() {

        if (whyCallback) {
            whyCallback(data.getWhy(), data.getQueryText());
        }
    });

    return view;
}

function makeNewSoloView(data, questionNumber) {
    var isPersonal = false;
    var answerGroupName = 'answer-group-' + questionNumber;
    var selectCallback = null,
        nextCallback = null,
        previousCallback = null,
        whyCallback = null;

    var $el = $(template);
    var $answersContainer = $el.find('.answers-container');


    var numberOfAnswers = data.numberOfAnswers;
    var $radios;

    var populate = function() {
        $el.find('.hero-title').html(data.getQueryText(isPersonal));
        $answersContainer.html('');

        for (var i = 0; i < numberOfAnswers; i += 1) {
            var labelText = data.getAnswerText(i, isPersonal);
            var $answer = makeAnswer(labelText, answerGroupName, i);
            var $answerInnerContainer = $('<div class="solo-question-answer-inner-container"></div>');
            $answerInnerContainer.append($answer);
            $answersContainer.append($answerInnerContainer);
        }

        $radios = $el.find('input[name="' + answerGroupName + '"]');
        $radios.change(function() {

            if (!!selectCallback) {

                selectCallback({
                    questionData: data,
                    answerNumber: parseInt($(this).val())
                });
            }

            var $selectedRadio = $('input[name=' + answerGroupName + ']:radio:checked');
            var $checkmark = $selectedRadio.next().find('img');
            $checkmark.fadeIn(250);

            $selectedRadio.siblings('.answer-label-text').addClass('selected-answer');

            var $unselectedRadio = $('input[name=' + answerGroupName + ']:radio:not(:checked)');
            var $checkmarkHide = $unselectedRadio.next().find('img');
            $unselectedRadio.siblings('.answer-label-text').removeClass('selected-answer');
            $checkmarkHide.fadeOut('fast');

            $next.prop('disabled', false);
        });
    };

    var $next = $el.find('.next-questions');
    var $previous = $el.find('.previous-questions');

    populate();
    var view = {
        $el: $el,
        updatePersonalTrack: function(p) {
            isPersonal = p;

        },
        onWhy: function(callback) {
            whyCallback = callback;
        },
        onAnswerSelect: function(callback) {
            selectCallback = callback;
        },
        onNext: function(callback) {
            nextCallback = callback;
        },
        onPrevious: function(callback) {
            previousCallback = callback;
        },
        reset: function() {
            $radios.prop('checked', false);
            $next.prop('disabled', true);

            var $unselectedRadio = $('input[name=' + answerGroupName + ']:radio:not(:checked)');
            $el.find('.answer-label-text').removeClass('selected-answer');
            var $checkmarkHide = $unselectedRadio.next().find('img');
            $checkmarkHide.hide(); //fadeOut('fast');
        },
        enabled: function(isEnabled, questionNumber, dontScrollOnStart, totalQuestions, resetAnswerOfCurrentQuestion) {
            if (!isEnabled) {
                $el.hide();

            } else {

                $el.fadeIn('fast');

                if (resetAnswerOfCurrentQuestion === true) {
                    view.reset();
                }

                $el.find('.question-number').html('Step ' + (questionNumber + 1) + ' of ' + totalQuestions);
            }
        },
        isLast: function() {
            $next.html('Submit');
        },
        clear: function() {
            $el.find('input').attr('checked', false);
        },
        get id() {
            return data.queryID;
        }
    };

    // if (data.startQuestion === true) {
    //     $previous.hide();
    // }

    $next.on('click', function() {
        if (!!nextCallback) {
            nextCallback();
        }
    });
    $previous.on('click', function() {
        if (!!previousCallback) {
            previousCallback();
        }
    });
    var $why = $el.find('.why-are-we-asking');

    $why.on('click', function() {

        if (whyCallback) {
            whyCallback(data.getWhy(), data.getQueryText());
        }
    });

    return view;
}



module.exports = makeNewView;